import { Button, Drawer, Empty, Skeleton, Space, Table } from "antd";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import RotoTemplateDetails from "./RotoTemplateDetails";
import { EditOutlined, EyeOutlined, LoadingOutlined } from "@ant-design/icons";
import { getRotoPaginationListNew } from "services/redux/Roto/action";
import InfiniteScroll from "react-infinite-scroll-component";

export default function RotoTemplateViewTable({
  filterData,
  setOpenForm,
  setUpdateData,
}) {
  const dispatch = useDispatch();
  const [data, setData] = useState("");
  const [viewDetailsDrawer, setViewDetailsDrawer] = useState(false);

  const [viewLoadingRecord, setViewLoadingRecord] = useState({
    key: null,
    isLoading: false,
  });
  const [editLoadingRecord, setEditLoadingRecord] = useState({
    key: null,
    isLoading: false,
  });

  const { rotoDetails, getRotoListingLoading } = useSelector(
    (state) => state.rotoReducer
  );

  const [logData, setLogData] = useState([]);
  const [currentPage, setCurrentpage] = useState(1);
  const pageSize = 10;

  const columns = [
    {
      title: "S No",
      key: "sno",
      render: (text, object, index) => index + 1,
      width: "3%",
    },
    {
      title: "Region",
      dataIndex: "region",
      key: "region",
      width: "10%",
    },
    {
      title: "tenderNo",
      dataIndex: "tenderNo",
      key: "tenderNo",
      width: "10%",
    },
    {
      title: "Client",
      dataIndex: "clientCompany",
      key: "clientCompany",
      width: "20%",
      render: (record) => {
        if (!isEmpty(record)) {
          return (
            <div style={{ display: "block", width: "100%" }}>
              {record.slice(0, 2).map((item, index) => (
                <span key={index}>{item?.name}</span>
              ))}
              {record.length > 2 && <span>...</span>}
            </div>
          );
        }
      },
    },
    {
      title: "projectName",
      dataIndex: "projectName",
      key: "projectName",
      width: "10%",
    },

    {
      title: "Procurement",
      dataIndex: "procurement",
      key: "procurement",
      width: "10%",
    },
    {
      title: "Bidding Company",
      dataIndex: "biddingCompany",
      key: "biddingCompany",
      width: "20%",
      render: (record) => {
        if (!isEmpty(record)) {
          return (
            <div style={{ display: "block", width: "100%" }}>
              {record.slice(0, 2).map((item, index) => (
                <div key={index}>
                  {item.companyInfo?.slice(0, 2).map((company) => (
                    <div key={company?.id}>{company?.name}</div>
                  ))}
                  {item.companyInfo?.length > 2 && <span>...</span>}
                </div>
              ))}
              {record.length > 2 && <span>...</span>}
            </div>
          );
        }
        return null;
      },
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
      width: "10%",
    },
    {
      title: "Notice Date",
      dataIndex: "noticeDate",
      key: "noticeDate",
      width: "10%",
      render: (record) => {
        if (!isEmpty(record)) {
          return moment(record).format("DD-MMM-YYYY");
        }
      },
    },
    {
      title: "Action",
      render: (record) => (
        <div>
          <div
            className="task-view-btn"
            style={{
              margin: "20px",
            }}
            onClick={() => handleEditClick(record)}
          >
            {editLoadingRecord.key === record.id &&
            editLoadingRecord.isLoading ? (
              <LoadingOutlined />
            ) : (
              <EditOutlined />
            )}
          </div>
          <div
            className="task-view-btn"
            style={{
              margin: "20px",
            }}
            onClick={() => handleViewClick(record)}
          >
            {viewLoadingRecord.key === record.id &&
            viewLoadingRecord.isLoading ? (
              <LoadingOutlined />
            ) : (
              <EyeOutlined />
            )}
          </div>
        </div>
      ),
      width: "7%",
    },
  ];

  // useEffect(() => {
  //   const params = {
  //     skipCount: 0,
  //     maxResultCount: 200,
  //   };
  //   dispatch(getRotoPaginationListNew(params));
  // }, []);

  // added
  useEffect(() => {
    dispatch(
      getRotoPaginationListNew(
        {
          skipCount: 0,
          maxResultCount: pageSize,
        },
        false
      )
    );
  }, []);

  useEffect(() => {
    if (!isEmpty(rotoDetails?.items)) {
      setLogData(rotoDetails?.items);
      const newCurrentPage = rotoDetails?.items?.length / pageSize;
      setCurrentpage(newCurrentPage);
    } else {
      setLogData([]);
    }
  }, [rotoDetails, currentPage, pageSize]);

  const getMoreData = () => {
    getData(pageSize, currentPage * pageSize, true);
  };

  const getData = (MaxResultCount = pageSize, SkipCount, loadMore = true) => {
    dispatch(
      getRotoPaginationListNew(
        {
          ...filterData,
          skipCount: SkipCount,
          maxResultCount: MaxResultCount,
        },
        loadMore
      )
    );
  };

  const handleEditClick = (record) => {
    setEditLoadingRecord({
      key: record.id,
      isLoading: true,
    });
    setUpdateData(record);
    setTimeout(() => {
      setOpenForm({
        modal: false,
        drawer: true,
        edit: true,
      });
      setEditLoadingRecord({
        key: null,
        isLoading: false,
      });
    }, 500); // Simulate a delay for loading
  };

  const handleViewClick = (record) => {
    setViewLoadingRecord({
      key: record.id,
      isLoading: true,
    });
    setData(record);
    setTimeout(() => {
      setViewDetailsDrawer(true);
      setViewLoadingRecord({
        key: null,
        isLoading: false,
      });
    }, 500); // Simulate a delay for loading
  };

  return !isEmpty(rotoDetails?.items) ? (
    <div
      id="rotoTemplateViewTable"
      style={{
        height: "calc(100vh - 125px)",
        overflow: "auto",
      }}
    >
      <InfiniteScroll
        dataLength={logData?.length}
        next={getMoreData}
        // next={() => {
        //   console.log("Scroll triggered");
        //   fetchData();
        // }}
        hasMore={rotoDetails?.totalCount > rotoDetails?.items?.length}
        loader={<Skeleton active={4} />}
        // endMessage={<p style={{ textAlign: "center" }}>No more data</p>}
        // endMessage={<p style={{ textAlign: "center" }}></p>}
        scrollThreshold={0.6}
        scrollableTarget="rotoTemplateViewTable"
      >
        <Table
          scroll={{ x: 1500 }}
          columns={columns}
          dataSource={logData}
          pagination={false}
          // loading={getRotoListingLoading}
          rowKey="id"
          // scroll={{ y: 200 }}
        />
      </InfiniteScroll>

      {/* <Table
        className="organizer__table contact-table"
        columns={columns}
        scroll={true}
        // rowClassName={setRowClassName}
        rowKey="appUserId"
        dataSource={rotoDetails?.items}
        sticky={true}
        // onChange={handleTableChange}
        loading={{
          // indicator: <img src={LogoImage} height="auto" width="50px" />,
          spinning: getRotoListingLoading,
        }}
      /> */}
      <Drawer
        visible={viewDetailsDrawer}
        title="Roto Details"
        placement="right"
        onClose={() => setViewDetailsDrawer(false)}
        width={543}
      >
        <RotoTemplateDetails data={data} />
      </Drawer>
    </div>
  ) : (
    <Empty />
  );
}
